import kanbanAPI from 'dashboard/api/kanban';

// Aviso ao cliente depois que o compromisso foi gravado (decisao 18).
// A previa e o envio continuam nos endpoints do cartao; o que mudou e QUANDO
// isso acontece: antes era um popup que abria sozinho, agora e a etapa de
// conferencia do formulario unico que pediu para enviar.
export const shouldNotify = payload =>
  Boolean(payload?.sendWhats && payload?.confirmation && payload?.kanbanItemId);

export const sendAppointmentNotice = async payload => {
  if (!shouldNotify(payload)) return false;
  try {
    await kanbanAPI.sendAppointmentConfirmation(
      payload.kanbanItemId,
      payload.confirmation
    );
    return true;
  } catch (error) {
    // O compromisso ja esta gravado. Falha de envio nao desfaz o agendamento.
    return false;
  }
};
